import React from 'react';
import { Button } from '@progress/kendo-react-buttons';

export const Downloadble: React.FC<{
  bgColor: string;
  icon: string;
  text: string;
  amount?: number;
  disabled?: boolean;
  downloadText?: string;
  onClick?: () => void;
}> = ({ text, icon, amount, bgColor, downloadText, disabled, onClick }) => {
  return (
    <div
      className={'w-100 h-100'}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '4px',
        padding: '13px 25px',
        backgroundColor: '#F8FCFE',
        boxShadow: '0px 4px 4px 0px #00000014'
      }}>
      <div className={'d-flex gap-3 align-items-center'}>
        <div
          style={{
            borderRadius: '5px',
            width: '50px',
            height: '50px',
            color: 'white',
            backgroundColor: bgColor,
            padding: '8px 4px'
          }}
          className={'d-flex align-items-center justify-content-center'}>
          <span className="material-symbols-outlined">{icon}</span>
        </div>
        <div className={'d-flex flex-column'}>
          <span>{text}</span>
          {amount !== undefined && (
            <span className={'fw-bold'} style={{ fontSize: '23px' }}>
              {amount < 10 ? `0${amount}` : amount}
            </span>
          )}
        </div>
      </div>

      {onClick && (
        <Button disabled={disabled} fillMode={'outline'} onClick={onClick}>
          {downloadText ? downloadText : 'Download'}
        </Button>
      )}
    </div>
  );
};
